var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5.25C5.25 3.1785 6.9285 1.5 9 1.5C11.0715 1.5 12.75 3.1785 12.75 5.25V7.5H13.05C13.71 7.5 14.25 8.04 14.25 8.7V13.95C14.25 14.94 13.44 15.75 12.45 15.75H5.55C4.56 15.75 3.75 14.94 3.75 13.95V8.7C3.75 8.04 4.29 7.5 4.95 7.5H5.25V5.25ZM11.25 5.25V7.5H6.75V5.25C6.75 4.0065 7.7565 3 9 3C10.2435 3 11.25 4.0065 11.25 5.25ZM9 9.1875C8.70175 9.18719 8.4123 9.28847 8.1793 9.47465C7.9463 9.66083 7.78367 9.92081 7.71817 10.2118C7.65268 10.5027 7.68823 10.8073 7.81899 11.0754C7.94974 11.3435 8.16789 11.559 8.4375 11.6865V13.5C8.4375 13.6492 8.49676 13.7923 8.60225 13.8977C8.70774 14.0032 8.85082 14.0625 9 14.0625C9.14918 14.0625 9.29226 14.0032 9.39775 13.8977C9.50324 13.7923 9.5625 13.6492 9.5625 13.5V11.6865C9.83211 11.559 10.0503 11.3435 10.181 11.0754C10.3118 10.8073 10.3473 10.5027 10.2818 10.2118C10.2163 9.92081 10.0537 9.66083 9.8207 9.47465C9.5877 9.28847 9.29825 9.18719 9 9.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUser);
export default __webpack_public_path__ + "static/media/header_user.680b9d97ece3d8277a0836864409e37c.svg";
export { ForwardRef as ReactComponent };